import MomentUtils from "@date-io/moment";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { InlineDatePicker } from "material-ui-pickers";
import moment from "moment";
import * as React from "react";
import colors from "../colors.scss";

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      main: colors.moodysBlue || "#009bdf"
    },
    error: {
      main: colors.darkCoral || "#f46036"
    }
  },
  typography: {
    useNextVariants: true
  }
});

interface DateInputProps {
  label: string;
  name: string;
  value: Date | null;
  onChange: (object: { [x: string]: Date }) => void;
  showDateInputError: boolean;
  placeholder: string;
  format: any;
}

class DateInput extends React.Component<DateInputProps> {
  public handleChange = (date: moment.Moment) => {
    if (date.isValid()) {
      this.props.onChange({ [this.props.name]: date.toDate() });
    }
  };

  public render() {
    return (
      <MuiThemeProvider theme={materialTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
          <InlineDatePicker
            autoOk={true}
            clearable={true}
            openToYearSelection={true}
            keyboard={true}
            variant="outlined"
            label={this.props.label}
            value={this.props.value}
            onChange={this.handleChange}
            format={this.props.format}
            error={this.props.showDateInputError && !this.props.value}
            mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
            placeholder={this.props.placeholder}
          />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/shared/DateInput.tsx